import { z } from 'zod';

const campaignSetting = z.object({
  id: z.number(),
  campaignId: z.number(),
  adSpend: z.number().nullable(),
  partner: z.string().nullable(),
});

export const campaignSettingsResponse = z.object({
  data: z.object({
    campaignSettings: z.array(campaignSetting),
  }),
});

export type CampaignSettingsResponse = z.infer<typeof campaignSettingsResponse>;

export const campaignSettingResponse = z.object({
  data: z.object({
    campaignSetting,
  }),
});

export type CampaignSettingResponse = z.infer<typeof campaignSettingResponse>;
